import ApiService from '@/services/api.service'
import { UserService } from '@/services/user.service'

export default class DealerService {
  importerType = null
  fetchedUsers = null
  systemGroups = {}

  resetSystemGroups() {
    this.systemGroups = {}
  }

  setSystemGroups(groups) {
    for (let group of groups) {
      this.systemGroups[group.id] = group
    }
  }

  setFetchedUsers(users) {
    this.fetchedUsers = users
  }

  setImporterType(importerType) {
    this.importerType = importerType
  }

  chunk(array, size) {
    const chunkedArr = []
    for (let i = 0; i < array.length; i += size) {
      chunkedArr.push(array.slice(i, i + size))
    }
    return chunkedArr
  }

  getPoints(user, calculate = false, pointValue = 0) {
    let points = 0
    if (calculate) {
      points = user.volumes
        .filter((volume) => {
          return (
            (!volume.filterAction || volume.filterAction !== 'skipCalculation') &&
            (volume.repair_item === undefined || volume.repair_item === false)
          )
        })
        .reduce(
          (acc, volume) => acc + volume.quantity * (volume.pointSetting !== undefined ? volume.pointSetting.points : pointValue),
          0
        )

      if (user.siblings.length) {
        user.siblings.forEach((sibling) => {
          points += this.getPoints(sibling, true)
        })
      }

      return points
    }

    points = user.volumes.reduce((acc, volume) => acc + volume.quantity, 0)
    if (user.siblings.length) {
      user.siblings.forEach((sibling) => {
        points += this.getPoints(sibling, true)
      })
    }

    return points
  }

  getAddedPoints(user) {
    let points = 0

    points = user.volumes.reduce((acc, volume) => acc + volume.resetted_points, 0)

    for (let volume of user.volumes) {
      if (volume.repair_item !== undefined && volume.repair_item === true) {
        points -= Math.abs(volume.quantity)
      }
    }

    if (user.siblings.length) {
      user.siblings.forEach((sibling) => {
        points += this.getAddedPoints(sibling)
      })
    }

    return points
  }

  getAddablePoints(user) {
    if (user.skip) {
      return 0
    }

    if (this.importerType.config.mode === 'merge') {
      return this.getPoints(user, true) - this.get(user.customerNumber, 'points', 0)
    }

    return this.getPoints(user, true)
  }

  getExcelUserPoints(users) {
    let points = 0
    for (let customerNumber in this.fetchedUsers) {
      if (users[customerNumber] === undefined) {
        continue
      }
      if (users[customerNumber].submit === true) {
        if (this.getAddablePoints(users[customerNumber]) === 0) {
          users[customerNumber].submit = -1
        }
        points += this.getAddablePoints(users[customerNumber])
      }
    }

    return points
  }

  switchUserForCustomerNumber(customerNumber, newUser) {
    const { multipleCustomerNumbers, ...user } = this.fetchedUsers[customerNumber]
    this.fetchedUsers[customerNumber] = {
      ...user,
      ...newUser,
      multipleCustomerNumbers: { ...multipleCustomerNumbers }
    }
  }

  async loadImporterDealers(customerNumbers, importerId) {
    try {
      const response = await ApiService.post(`points-importer/importer/${importerId}/dealers`, {
        customer_numbers: customerNumbers
      })
      if (response.status == 200) {
        return response.data
      }
    } catch (error) {
      return error.response
    }
  }

  async fetchUsersInChunks(users, importerType, progress = (progress) => {}) {
    let fetchCounter = 1,
      results = []

    const customerNumbers = users.map((user) => user.customerNumber),
      chunks = this.chunk(customerNumbers, 150),
      maxPromiseChunk = this.chunk(chunks, 10)

    for (let i = 0; i < maxPromiseChunk.length; i++) {
      let promises = maxPromiseChunk[i].map((chunk, index) =>
        this.loadImporterDealers(chunk, importerType.id).then((result) => {
          if (progress) {
            progress(Math.round((fetchCounter / chunks.length) * 100))
            fetchCounter++
          }
          return result
        })
      )

      results = results.concat(await Promise.all(promises))
    }

    let flattenedResults = results.flat()

    flattenedResults = flattenedResults.reduce((acc, user) => {
      if (acc[user.customer_number] !== undefined) {
        acc[user.customer_number].submit = false
        if (acc[user.customer_number].multipleCustomerNumbers === undefined) {
          const clonedUser = { ...acc[user.customer_number] }
          acc[user.customer_number].multipleCustomerNumbers = [clonedUser]
        }
        acc[user.customer_number].multipleCustomerNumbers.push(user)
        return acc
      }

      acc[user.customer_number] = user
      return acc
    }, {})

    this.fetchedUsers = flattenedResults

    return flattenedResults
  }

  mapUsersByCustomerNumber(users, importerMode, importAllUsers = false) {
    const userGroupMapper = []

    return users.reduce((acc, user) => {
      acc[user.customerNumber] = user

      // Check if customer number has points
      if (
        this.fetchedUsers[user.customerNumber] !== undefined &&
        (importerMode !== 'merge' ||
          (this.getPoints(user, true) - this.get(user.customerNumber, 'points', 0) != 0 && importerMode === 'merge'))
      ) {
        if (this.fetchedUsers[user.customerNumber].multipleCustomerNumbers === undefined) {
          acc[user.customerNumber].submit = true
        }
      } else {
        acc[user.customerNumber].submit = -1
      }

      if (this.fetchedUsers[user.customerNumber] !== undefined) {
        let group_id = this.fetchedUsers[user.customerNumber].dealer.profile.group_id

        acc[user.customerNumber].volumes.forEach((volume) => {
          volume.user.group_id = [group_id]

          if (this.systemGroups[group_id] !== undefined) {
            volume.user.group_id.push(this.systemGroups[group_id].parent_id)
          } else {
            console.log('Pls check user group id for customer number ' + user.customerNumber + ', it seams missing: ', group_id)
          }
        })
      }

      // build siblings
      if (this.fetchedUsers[user.customerNumber] !== undefined && this.fetchedUsers[user.customerNumber].dealer_id !== null) {
        if (userGroupMapper[this.fetchedUsers[user.customerNumber].dealer_id] === undefined) {
          userGroupMapper[this.fetchedUsers[user.customerNumber].dealer_id] = user.customerNumber
        } else {
          acc[user.customerNumber].skip = true

          acc[userGroupMapper[this.fetchedUsers[user.customerNumber].dealer_id]].siblings.push(user)
        }
      }

      return acc
    }, {})
  }

  addPointSettings(users, importerRules, groups) {
    for (let customerNumber in users) {
      users[customerNumber].volumes.forEach((volume) => {
        const group = groups[users[customerNumber].group_id]
        const userGroupId = group !== undefined ? group.parent_id : undefined
        volume.pointSetting = this.findPointSetting(volume, users[customerNumber].columnSetConfig, importerRules, userGroupId)
      })
    }

    return users
  }

  findPointSetting(row, columnSetConfig, importerRules, userGroupId = undefined) {
    return importerRules.find((pointSetting) => {
      if (pointSetting.inches_from === pointSetting.inches_to) {
        return (
          parseInt(row.rim) === pointSetting.inches_to &&
          (row.brand === undefined || pointSetting.brand === row.brand) &&
          (columnSetConfig?.level === undefined || pointSetting.level === columnSetConfig?.level) &&
          (userGroupId === undefined ||
            columnSetConfig?.import_settings_by_group_id === undefined ||
            (columnSetConfig?.import_settings_by_group_id === true && userGroupId === pointSetting.group_id))
        )
      }

      return (
        parseInt(row.rim) >= pointSetting.inches_from &&
        parseInt(row.rim) <= pointSetting.inches_to &&
        (row.brand === undefined || pointSetting.brand === row.brand) &&
        (columnSetConfig.level === undefined || pointSetting.level === columnSetConfig.level) &&
        (userGroupId === undefined ||
          columnSetConfig.import_settings_by_group_id === undefined ||
          (columnSetConfig.import_settings_by_group_id === true && userGroupId === pointSetting.group_id))
      )
    })
  }

  groupVolumes(user) {
    user.groupedVolumes = []
    user.groupedVolumes = user.volumes.reduce((acc, volume) => {
      let key = ''

      if (volume.pointSetting === undefined) {
        let errorIndex = 1
        key = `${volume.rim}-${volume.brand}-error-${errorIndex}`

        while (acc[key] !== undefined) {
          errorIndex++
          key = `${volume.rim}-${volume.brand}-error-${errorIndex}`
        }
      } else {
        key = `${volume.rim}-${volume.brand}-${volume.pointSetting.id}`
      }

      if (!acc[key]) {
        acc[key] = {
          rim: volume.rim,
          brand: volume.brand,
          pointSetting: volume.pointSetting,
          quantity: 0
        }
      }

      acc[key].quantity += volume.quantity

      return acc
    }, {})
  }

  getSelectedDealerCustomerNumbers(users, sibling = false) {
    let customerNumbers = {}
    for (let index in users) {
      if (sibling || users[index].submit === true) {
        customerNumbers[users[index].customerNumber] = true
        if (users[index].siblings.length) {
          customerNumbers = {
            ...customerNumbers,
            ...this.getSelectedDealerCustomerNumbers(users[index].siblings, true)
          }
        }
      }
    }

    return customerNumbers
  }

  get(customerNumber, key = null, defaultReturn = null) {
    if (this.fetchedUsers[customerNumber] === undefined) {
      return defaultReturn
    }

    if (key !== null) {
      if (this.fetchedUsers[customerNumber][key] !== undefined) {
        return this.fetchedUsers[customerNumber][key]
      }
      if (this.fetchedUsers[customerNumber].dealer[key] !== undefined) {
        return this.fetchedUsers[customerNumber].dealer[key]
      }

      return defaultReturn
    }

    return this.fetchedUsers[customerNumber]
  }
}
